import React from 'react';
import SvgCsv from '../../../../assets/icons/Csv';
import IconsComponents from '../Styles/styledComponent';

function Csv() {
  return (
    <IconsComponents.Container>
      <SvgCsv />
    </IconsComponents.Container>
  );
}

export default Csv;
